import React from "react";
import PropTypes from "prop-types";
import CarAnimationLoader from "../car-animation-loader";

const RtoInfoLoader = ({
    title = "Fetching vehicle details",
    description = "Please stay on this page. It takes a few seconds to get the details from your RTO.",
    isVariant = false
}) => {

    return <CarAnimationLoader title={title} description={description} showCheckMark={false} isVariant={isVariant} />;
};

RtoInfoLoader.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    isVariant: PropTypes.bool
};

export default RtoInfoLoader;
